import { render } from "./BulbAnimationScreen.vue?vue&type=template&id=25837af4&scoped=true&ts=true"
import script from "./BulbAnimationScreen.vue?vue&type=script&lang=ts"
export * from "./BulbAnimationScreen.vue?vue&type=script&lang=ts"

import "./BulbAnimationScreen.vue?vue&type=style&index=0&id=25837af4&scoped=true&lang=css"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25837af4"]])

export default __exports__